export default ({ currentMarket, detectedCountry }) => {
  if (['GB', 'US'].includes(detectedCountry)) {
    return currentMarket === 'INT' ? 'DE' : currentMarket
  }

  return currentMarket === 'INT' ? detectedCountry : currentMarket
}
